import { Controller } from "@hotwired/stimulus"
import { MorphButton } from "~/src/web/morph_button"

export default class extends Controller {
  connect() {
    MorphButton(this.element, { closeEl : ".modal-close" });
  }
}
